module.exports = __webpack_public_path__ + "img/Slice4.466b3779.png";